<template>
  <section>
    <Intro v-if="!isConfigured"></Intro>
    <Oversight v-if="isConfigured"></Oversight>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import Intro from "@/components/dashboard/Intro";
import Oversight from "@/components/dashboard/Oversight";

export default {
  data: () => ({
    loading: false
  }),
  created() {},
  mounted() {},
  computed: {
    ...mapGetters("apiAuth", ["user"]),
    isConfigured() {
      return (
        this.user &&
        this.user.account &&
        this.user.account.subscription &&
        (this.user.account.subscription.paypal_subscription || this.user.account.subscription.free) &&
        this.user.account.bots &&
        this.user.account.bots.length
      );
    },
  },
  methods: {},
  watch: {},
  components: {
    Intro,
    Oversight
  },
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>